/* eslint react/no-multi-comp: 0 */
/* eslint react/jsx-no-literals: 0 */

import React from 'react';
import {formatNumber} from 'common/formatters/number-formatter';

/* TODO i18n */

export const subStyle = {
  fontSize: '75%',
  lineHeight: 0,
  position: 'relative',
  verticalAlign: 'baseline',
  top: '0.5em',
};

export const supStyle = {
  fontSize: '75%',
  lineHeight: 0,
  position: 'relative',
  verticalAlign: 'baseline',
  top: '-0.5em',
};

export const subscriptMap = {
  CO2: (
    <span>
      CO<sub style={subStyle}>2</sub>
    </span>
  ),
  'lbs CO2': (
    <span>
      lbs CO<sub style={subStyle}>2</sub>
    </span>
  ),
  't CO2': (
    <span>
      t CO<sub style={subStyle}>2</sub>
    </span>
  ),
  'Mt CO2': (
    <span>
      Mt CO<sub style={subStyle}>2</sub>
    </span>
  ),
};

export const superscriptPattern = /(\^\d)/g;

export const sqft = () => (
  <span>
    ft<sup style={supStyle}>2</sup>
  </span>
);

export const sqm = () => (
  <span>
    m<sup style={supStyle}>2</sup>
  </span>
);

// Superscript styles from: https://gist.github.com/unruthless/413930
export const formatUnitsJSX = (units) => {
  if (units in subscriptMap) {
    return subscriptMap[units];
  }

  const split = (units || '').split(superscriptPattern);
  if (split.length) {
    return (
      <span>
        {split
          // Filter empty strings
          .filter((item) => item)
          .map((fragment, index) =>
            index % 2 === 0 ? (
              <span key={`fragment-${index}`}>{fragment}</span>
            ) : (
              <sup key={`fragment-${index}`} style={supStyle}>
                {fragment.slice(1, 2)}
              </sup>
            ),
          )}
      </span>
    );
  }

  return units;
};

export const formatUnits = (shortName) => {
  return (
    shortName
      // Due to the shortName "CO2" being used in many places
      // without calling this function, we will keep the shortName
      // on the backend the same, and replace it accordingly here
      .replace(/CO2/g, 'CO\u2082')
      .replace(/\_2/g, '\u2082')
      .replace(/\^2/g, '\u00B2')
      .replace(/\^3/g, '\u00B3')
  );
};

export const formatNormalizerUnit = (normalizerUnit) => {
  if (!normalizerUnit) {
    return '';
  }

  let shortName;
  if (typeof normalizerUnit === 'string') {
    shortName = normalizerUnit;
  } else {
    shortName = normalizerUnit.shortName;
  }

  const SINGULAR_MAP = {
    occupants: 'occupant',
    days: 'day',
  };
  const singular = SINGULAR_MAP[shortName];
  const unit = formatUnits(singular || shortName);
  return `/${unit}`;
};

export const formatReadout = (
  units,
  value,
  normalizerUnit,
  formatter = null,
) => {
  let readout = '';

  if (value === null || isNaN(value)) {
    return {readout};
  }

  const isDollars = units === '$';
  const normalizerReadout = formatNormalizerUnit(normalizerUnit);
  const formattedValue = (formatter || formatNumber)(value);
  readout = isDollars
    ? `$${formattedValue}${normalizerReadout}`
    : `${formattedValue} ${formatUnits(units)}${normalizerReadout}`;

  return {readout};
};

export const areaUnitter = (value, building) => {
  /* TODO i18n, match on shortName not possible with translation */
  if (
    building &&
    building.areaUnit &&
    (building.areaUnit.shortName === 'sq m' ||
      building.areaUnit.shortName === 'm^2')
  ) {
    return sqm(value);
  }
  return sqft(value);
};

export const getAreaUnit = () => {
  if (
    window &&
    window.settings &&
    window.settings.organization &&
    window.settings.organization.areaUnit
  ) {
    return window.settings.organization.areaUnit;
  }
  return {};
};

export const getTemperatureUnit = () => {
  if (
    window &&
    window.settings &&
    window.settings.organization &&
    window.settings.organization.tempUnit
  ) {
    return window.settings.organization.tempUnit;
  }
  return {};
};

export const getIsCurrency = (units) => {
  const isCurrency = units === '$';
  return isCurrency;
};
